import { Controller } from "@hotwired/stimulus";

const RESET_DELAY_MS = 2500;

export default class extends Controller {
  static targets = ["text", "tooltip"];

  click() {
    const copyText = this.textTarget;
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(copyText.value);
    this.tooltipTarget.innerHTML = "¡Copiado!";
    clearTimeout(this.resetTimeout);
    this.resetTimeout = setTimeout(() => this.resetTooltip(), RESET_DELAY_MS);
  }

  onmouseout() {
    // Revert is handled by the click timeout so "Copiado" stays visible.
  }

  resetTooltip() {
    this.tooltipTarget.innerHTML = "Copiar";
  }

  disconnect() {
    clearTimeout(this.resetTimeout);
  }
}
